import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import { RobotoButton } from "@/shared/components";
import { Menu } from "@/shared/components/Menu";
import { FileRecord } from "@/shared/domain/files";
import { usePopupState } from "@/shared/hooks";

import { FileDetails } from "../FileDetails";

import { DownloadFile } from "./DownloadFile";
import { OpenFileInNewTab } from "./OpenFileInNewTab";
import { ViewTagsAndMetadata } from "./ViewTagsAndMetadata";

interface ViewFileControlsProps {
  fileRecord: FileRecord | undefined;
}

export function ViewFileControls({ fileRecord }: ViewFileControlsProps) {
  const dropdownMenu = usePopupState();
  const tagMetadataPopup = usePopupState();

  if (!fileRecord) {
    return (
      <RobotoButton
        disabled={true}
        endIcon={<KeyboardArrowDownIcon />}
        size="small"
        variant="outlined"
        eventName={"FileActionsClicked"}
        eventProperties={{ fileId: "" }}
        sx={{
          minHeight: "2.3rem",
        }}
      >
        File Actions
      </RobotoButton>
    );
  }

  return (
    <>
      <RobotoButton
        endIcon={<KeyboardArrowDownIcon />}
        eventName={"FileActionsClicked"}
        eventProperties={{ fileId: fileRecord.file_id }}
        onClick={function openAddPanelMenu(event) {
          dropdownMenu.open({ anchorEl: event.currentTarget });
        }}
        size="small"
        variant="outlined"
        sx={{
          minHeight: "2.3rem",
        }}
      >
        File Actions
      </RobotoButton>
      <Menu
        anchorEl={dropdownMenu.anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={dropdownMenu.isOpen}
        onClose={dropdownMenu.close}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <ViewTagsAndMetadata
          onClick={function openTagsAndMetadata() {
            tagMetadataPopup.open();
            dropdownMenu.close();
          }}
        />
        <DownloadFile fileRecord={fileRecord} onClick={dropdownMenu.close} />
        <OpenFileInNewTab
          fileRecord={fileRecord}
          onClick={dropdownMenu.close}
        />
      </Menu>
      <Dialog
        open={tagMetadataPopup.isOpen}
        fullWidth
        maxWidth={"md"}
        onClose={tagMetadataPopup.close}
      >
        <DialogTitle>File Details</DialogTitle>
        <DialogContent>
          <FileDetails fileRecord={fileRecord} />
        </DialogContent>
      </Dialog>
    </>
  );
}
